export const PublicPortalEntities = {
    P_APPLICATION: "P_APPLICATION",
    P_APPLICATION_TYPE: "P_APPLICATION_TYPE",
    P_APPEAL: "P_APPEAL",
    P_APPEAL_TYPE: "P_APPEAL_TYPE",
    P_DECISION_TYPE: "P_DECISION_TYPE",
    P_COMMENT: "P_COMMENT",
    PUBLIC_P_NOTIFICATION_RESPONSE: "PUBLIC_P_NOTIFICATION_RESPONSE",
    P_CONSULTEE: "P_CONSULTEE",
    PUBLIC_P_CONSULTEE_RESPONSE: "PUBLIC_P_CONSULTEE_RESPONSE",
    P_CONSULTEE_COMMENT: "P_CONSULTEE_COMMENT",
    P_GENERAL_CONSTRAINT_RESULT: "P_GENERAL_CONSTRAINT_RESULT",
    P_PLANNING_CONSTRAINT_RESULT: "P_PLANNING_CONSTRAINT_RESULT",
    P_TRACKED_APPLICATION_NOTIFICATIONS: "P_TRACKED_APPLICATION_NOTIFICATIONS",
    P_WEEKLY_LIST: "P_WEEKLY_LIST",
    PPP_SAVED_SEARCH: "PPP_SAVED_SEARCH",
    PPP_TRACKED_APPLICATION: "PPP_TRACKED_APPLICATION",
    E_APPLICATION: "E_APPLICATION",
    E_NOTICE: "E_NOTICE",
    E_NOTICE_TYPE: "E_NOTICE_TYPE",
    E_APPEAL: "E_APPEAL",
    E_APPEAL_DECISION_TYPE: "E_APPEAL_DECISION_TYPE",
    USER_: "USER_",
    BC_APPLICATION: "BC_APPLICATION",
    BC_APPLICATION_TYPE: "BC_APPLICATION_TYPE",
    BC_COMPETENT_PERSON_SCHEMA: "BC_COMPETENT_PERSON_SCHEMA",
} as const;
export type PublicPortalEntities = typeof PublicPortalEntities[keyof typeof PublicPortalEntities];
